import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const TYPE_COLORS = {holiday: 'bg-red-100 text-red-700', pto: 'bg-blue-100 text-blue-700', birthday: 'bg-pink-100 text-pink-700'};

export default function TeamCalendar() {
  const [events, setEvents] = useState([]);
  const [month, setMonth] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });

  useEffect(() => {
    const m = `${month.getFullYear()}-${String(month.getMonth() + 1).padStart(2, '0')}`;
    api(`/hcm/my-team-calendar?month=${m}`).then(r => r.ok ? r.json() : []).then(setEvents).catch(() => {});
  }, [month]);

  const firstDay = month.getDay();
  const daysInMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const today = new Date();
  const eventsByDay = {};
  events.forEach(ev => {
    const day = new Date(ev.date + 'T00:00:00').getDate();
    if (!eventsByDay[day]) eventsByDay[day] = [];
    eventsByDay[day].push(ev);
  });

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Team Calendar</h2>
      <div className="bg-white rounded-lg shadow">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))} className="text-gray-500 hover:text-gray-700 text-lg">←</button>
          <h3 className="text-lg font-semibold text-gray-900">{month.toLocaleDateString(undefined, {month: 'long', year: 'numeric'})}</h3>
          <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))} className="text-gray-500 hover:text-gray-700 text-lg">→</button>
        </div>
        <div className="grid grid-cols-7">
          {DAYS.map(d => <div key={d} className="px-2 py-2 text-center text-xs font-medium text-gray-500 border-b">{d}</div>)}
          {cells.map((day, i) => {
            const isToday = day && month.getMonth() === today.getMonth() && month.getFullYear() === today.getFullYear() && day === today.getDate();
            const dayEvents = day ? (eventsByDay[day] || []) : [];
            return (
              <div key={i} className={`min-h-[90px] border-b border-r p-1 ${day ? '' : 'bg-gray-50'}`}>
                {day && (
                  <>
                    <div className={`text-xs font-medium mb-1 ${isToday ? 'bg-indigo-600 text-white w-6 h-6 rounded-full flex items-center justify-center' : 'text-gray-500 px-1'}`}>{day}</div>
                    <div className="space-y-0.5">
                      {dayEvents.map((ev, j) => (
                        <div key={j} className={`px-1.5 py-0.5 rounded text-xs truncate ${TYPE_COLORS[ev.type] || 'bg-gray-100 text-gray-600'}`}>{ev.label}</div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex gap-4 mt-4 text-xs text-gray-500">
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-red-100"></span> Holiday</span>
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-blue-100"></span> PTO</span>
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-pink-100"></span> Birthday</span>
      </div>
    </Layout>
  );
}
